// @ts-expect-error pure js
import { currencyFormatter } from "../../api/Functions";
import type { RentabiliteWarning } from "../../models/statsRentabilite";

export function warningMessage(warning: RentabiliteWarning): string {
  switch (warning.code) {
    case "prix_achat_manquant":
      return "Prix d'achat non renseigné : la rentabilité ne peut pas être calculée. Renseignez-le dans la fiche du bien.";
    case "aucun_pret":
      return "Aucun prêt rattaché : le cashflow ne déduit aucune mensualité. Si un prêt finance ce bien, ajoutez-le dans l'onglet Prêts de votre profil et rattachez-le au bien.";
    case "pret_sans_echeancier":
      return "Un prêt est rattaché mais son échéancier est vide : complétez sa date de début, sa durée et ses événements.";
    case "aucune_depense":
      return "Aucune dépense enregistrée sur la période : pensez à affecter vos charges (taxe foncière, copropriété, assurance…) au bien pour une rentabilité nette fiable.";
    case "charges_non_affectees":
      return `${warning.count} dépense(s) pour ${currencyFormatter(
        warning.montant ?? 0,
      )} ne sont affectées à aucun bien : elles sont exclues des indicateurs par bien.`;
    case "transactions_non_affectees":
      return `${warning.count} transactions bancaires (${currencyFormatter(
        warning.montant ?? 0,
      )} de dépenses, ${currencyFormatter(
        warning.montant_recettes ?? 0,
      )} de recettes) ne sont rattachées à aucune écriture : elles n'entrent pas dans les indicateurs. Affectez-les depuis le menu Banque.`;
    case "prix_achat_mixte":
      return "Un prix d'achat est renseigné à la fois sur l'immeuble et sur certains biens : celui de l'immeuble est utilisé pour la ligne immeuble.";
  }
}
